import { useEffect, useState } from "react";
import { readStoredString, writeStoredString } from "../../shared/storage/storedString";

/**
 * Whether a sidebar or a page column is open (web-app.md WA-1), kept in local storage under
 * `storageKey` so it stays as the user left it. Nothing stored yet means `openByDefault`.
 */
export function useStoredOpen(storageKey: string, openByDefault: boolean): readonly [boolean, (open: boolean) => void] {
  const [open, setOpen] = useState(() => {
    const stored = readStoredString(storageKey);
    return stored === null ? openByDefault : stored !== "false";
  });

  useEffect(() => {
    writeStoredString(storageKey, String(open));
  }, [storageKey, open]);

  return [open, setOpen] as const;
}
